import React, { Fragment } from "react";
import { makeStyles } from "@mui/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    DialogActions,
    Button,
    IconButton,
    Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import cx from "classnames";
import theme from "../../../theme";

const useStyles = makeStyles({
    root: {
        padding: "8px 50px 40px"
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.primary.main,
    },
    dialogHeader: {
        textAlign: "center"
    },
    dialogBody: {
        // maxHeight: "230px",
        "&::-webkit-scrollbar": {
            width: "8px"
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ebebeb",
            borderRadius: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: "#9299b9"
        }
    },
    dialogActions: {
        justifyContent: "center",
        marginTop: theme.spacing(2.5)
    }
});

interface DefaultDialogProps {
    size: any;
    open: boolean;
    handleClose: any;
    header: any;
    actions: any;
    children: any;
    customStyles?: any;
}

const DefaultDialog = ({ size, open, handleClose, header, actions, children, customStyles = {} }: DefaultDialogProps) => {
    const classes = useStyles();
    const { t } = useTranslation("common");

    return (
        <Dialog
            maxWidth={size || "sm"}
            open={open}
            onClose={handleClose}
            classes={{
                paper: cx({
                    [customStyles.paper]: (customStyles && customStyles.paper),
                    [classes.root]: true
                })
            }}
            aria-labelledby="customized-dialog-title"
            fullWidth={true}
        >
            {header && (
                <DialogTitle className={classes.dialogHeader}>
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={handleClose}
                        size="large">
                        <CloseIcon />
                    </IconButton>
                    {header}
                </DialogTitle>
            )}
            <DialogContent className={classes.dialogBody} classes={{ root: (customStyles) ? customStyles.contentRoot : {} }}>
                {children}
            </DialogContent>
            {actions &&
                <DialogActions className={classes.dialogActions}>
                    {actions}
                </DialogActions>
            }
        </Dialog>
    );
};

export default DefaultDialog;
